import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">特色优势</h2>
          <p className="text-sm md:text-base text-foreground-600">为什么三百万读者选择耽耽漫画</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {featureItems.map((item, i) => (
            <div key={item.id} className="relative bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70 text-center group hover:scale-[1.02] transition-all duration-300 cursor-pointer">
              <div className={`w-16 h-16 md:w-18 md:h-18 rounded-2xl flex items-center justify-center mx-auto mb-5 ${
                i === 0 ? 'bg-primary-100' : i === 1 ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${item.icon} text-2xl md:text-3xl ${
                  i === 0 ? 'text-primary-500' : i === 1 ? 'text-accent-500' : 'text-secondary-500'
                } w-8 h-8 md:w-9 md:h-9 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}